export default __webpack_public_path__ + "assets/uv-index-8.f0760315.svg";